<template>
    <div class="container">
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img class="img" :src="item">
            <div class="activityImg" v-if="activity.isShow && index == 0">
                <img :src="activity.H5activeImg">
            </div>
        </div>
        <div class="section-main">
            <div class="s-main">
                <van-tabs v-model="active">
                    <van-tab v-for="(item, index) in stageList" :key="index" :title="item.stage" class="tb">
                        <div class="t-title">
                            {{item.title}}
                        </div>
                        <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png">
                        <div class="target">
                            <div class="title">
                                <div class="target-link"></div>
                                <div class="text">学习目标</div>
                                <div v-if="item.details.length > 0" class="btn" @click="showModal(item)"></div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.phaseTargetList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                            <div class="title title1">
                                <div class="target-link"></div>
                                <div class="text">关键技术点</div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.skillsList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
            <div class="tips-tab">
                * 具体课程内容以实际课程安排和进度为准
            </div>
            <button class="btn-receive" @click="JumpFn">
                <img :src="btnImg.receive">
            </button>
        </div>
        <div class="section" v-for="(item, index) in imgList1" :key="index">
            <img class="img" :src="item">
        </div>
        <div class="sw-section">
            <div class="sw-1">
                <div class="swiper-container current-wrap" >
                    <div class="swiper-wrapper current-wraps">
                        <div class="swiper-slide current-box" v-for="(item, index) in swiperList" :key="index">
                            <img :src="item">
                        </div>
                    </div>
                    <div class="swiper-pagination current-pagination" />
                </div>
            </div>
        </div>
        <button class="btn-btn1" @click="JumpFn">
            <img :src="btnImg.btn1">
        </button>
        <div class="section" v-for="(item, index) in imgList2" :key="index">
            <img class="img" :src="item">
            <button v-if="index == 1" class="btn-btn2" @click="JumpFn"></button>
        </div>

        <button class="footer" @click="JumpFn">
            <img class="icon_img" :src="btnImg.icon">
            <img class="img" :src="btnImg.footer">
           <FooterPoup
                :id="134"
                :isDcsj="false"
            />
        </button>

        <div :class="{'modal-container': true, active: modalVisable}" v-if="modalVisable">
            <div :class="{'layer': true, active: modalVisable}"/>
            <div class="modal">
                <div class="modal-content active">
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div>
                        <div class="title">
                            {{ moadlData.title }}
                            <div class="sub-title">
                                {{ moadlData.stage }}
                            </div>
                        </div>
                        <div class="content">
                            <div v-for="(val,inde) in moadlData.details" :key="inde" class="item">
                                <div class="content-title">
                                    {{val.t}}
                                </div>
                                <div class="content-desi" v-for="(i,its) in val.desc" :key="its">
                                    {{i}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import { Tab, Tabs } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import List from './list'
import activity from '../../../common/activity';
export default {
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
    },
    data() {
        return {
            activity,
            List,
            imgList:[],
            imgList1:[],
            imgList2:[],
            stageList:[],
            swiperList:[],
            modalVisable:false,
            btnImg:{},
            moadlData:{},
        }
    },
    mounted () {
        setTimeout(()=>{
            this.eduPlatTrack('WebView', { page_id: '1r93'});
        },500)
        let dataList = this.List.data.h5;
        this.imgList = dataList.imgList
        this.imgList1 = dataList.imgList1
        this.imgList2 = dataList.imgList2
        this.swiperList = dataList.swiperList
        
        this.btnImg = dataList.btnImg



        this.stageList = this.List.data.stageList

        this.renderSwipers()
    },
    methods: {
        JumpFn() {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1r93',
                'button_name': '限时领取'
            });
            handleJumpUrl(`1a06e29ba67b45b3aa2166a14cd7e530`);
        },
        closeModal(){
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);
        },
        showModal(item){
            console.log(item);
            this.fixedBody();
            this.modalVisable = true;
            this.moadlData = item
        },
        renderSwipers() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 800,
                autoplayDisableOnInteraction: false,
                autoplay: 3200,
                spaceBetween: 30,
                pagination: '.current-pagination',
            };
           
            this.$nextTick(() => {
                const swipers = new Swiper('.current-wrap', option);
            });
        },

    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background: #fff;
    padding-bottom: 230px;
    .section {
        position: relative;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
        .btn-btn2 {
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: 50px;
            width: 500px;
            height: 120px;
            border: none;
            background: transparent;
            z-index: 2;
        }
    }
    .section-main {
        position: relative;
        width: 100%;
        padding-top: 30px;
        background-color: #fff;
        padding-bottom: 80px;
        .s-main {
            margin: 0 auto;
            width: 688px;
            background-color: #fff;
            box-shadow: 0px 8px 12px 0px rgba(225, 225, 225, 0.39);
            z-index: 2;
            border-radius: 8px;
            padding-bottom: 140px;
            .tb {
                position: relative;
                width: 100%;
                background-color: #fff;
                .t-title {
                    text-align: center;
                    font-size: 32px;
                    color: #555;
                    font-weight: 500;
                    padding: 25px 0 10px;
                }
                .t-icon {
                    width: 688px;
                    display: block;
                    height: 2px;
                }
                .target {
                    color: #3D3D3F;
                    font-size: 26px;
                    margin-top: 35px;
                    .title {
                        display: flex;
                        height: 49px;
                        align-items: center;
                        font-weight: bold;
                    }
                    .title1 {
                        margin-top: 38px;
                    }
                    .target-link {
                        width: 6px;
                        height: 22px;
                        background: linear-gradient(313deg, #7A7AA9 0%, #232545 100%);
                        margin-left: 46px;
                        margin-right: 8px;
                    }
                    .text {
                        flex: 1;
                    }
                    .btn {
                        width: 151px;
                        height: 49px;
                        background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40px;
                    }
                    .content {
                        margin-top: 10px;
                    }
                    .content-list {
                        display: flex;
                        color: #595959;
                        line-height: 48px;
                        font-size: 24px;
                        .icon {
                            width: 8px;
                            height: 8px;
                            background: #565659;
                            border-radius: 50%;
                            margin-left: 46px;
                            margin-top: 20px;
                            margin-right: 8px;
                        }
                        .text {
                            opacity: .7;
                            flex: 1;
                            width: 612px;
                            padding-right: 14px;
                        }
                    }
                }
            }
        }
        /deep/ .van-tabs__wrap--scrollable{
            height: 106px;
        }
        /deep/ .van-tabs__nav {
            background: #F6F6F6;
            height: 106px;
        }
        /deep/ .van-tabs__wrap {
            height: 106px;
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        /deep/ .van-tab {
            width: 200px;
            height: 106px;
            color: #333333;
            font-size: 28px;
            font-weight: 400;
        }
        /deep/.van-tab--active {
            color: #2F41F7;
        }
        /deep/ .van-tabs__line {
            bottom: 40px;
            background: #2F41F7;
            width: 64px;
            height: 6px;
        }
        .tips-tab {
            font-size: 14px;
            color: #666;
            position: absolute;
            right: 60px;
            bottom: 160px;
        }
        .btn-receive {
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: 20px;
            width: 520px;
            height: 120px;
            border: none;
            background: transparent;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .sw-section {
        width: 100%;
        .sw-1 {
            width: 100%;
            /deep/.current-wrap {
                width: 690px;
                margin: 40px auto;
                .current-wraps {
                    width: 690px;
                    margin: 0 auto;
                    height: 640px;
                    .current-box {
                        width:100% !important;
                        img {
                            width: 100%;
                            display: block;
                        }
                    }
                }
                .swiper-pagination {
                    bottom: 0px;
                }
                .swiper-pagination-bullet{
                    width: 8px;
                    height: 8px;
                    background: #2F41F7;
                    border-radius: 50%;
                    opacity: .4;
                    &-active{
                        border-radius: 8px;
                        width: 20px;
                        background: #2F41F7;
                        opacity: 1;
                    }
                }
            }
        }
    }
    .btn-btn1 {
        display: block;
        margin: 0 auto 20px;
        width: 488px;
        height: 98px;
        border: none;
        background: transparent;
        img {
            width: 100%;
            display: block;
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        .icon_img {
            position: absolute;
            right: 40px;
            top: -46px;
            width: 209px;
            height: 63px;
        }
        .img {
            width: 100%;
            display: block;
        }
    }
}
.layer {
    position: fixed;
    z-index: 9;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    display: none;
    &.active {
        display: block;
    }
}
.modal {
    position: fixed;
    bottom: 180px;
    z-index: 10;
    display: flex;
    justify-content: center;
    .modal-content {
        width: 750px;
        height: 0;
        opacity: 0;
        transition: height .3s linear;
        overflow-y: scroll;
        // padding-bottom: 100px;
        &.active {
            opacity: 1;
            height: 962px;
            overflow: hidden;
        }
        background: #fff;
        border-radius: 18px 18px 0 0;
        position: relative;
        margin-right: 45px;
        box-sizing: border-box;
    }
    .close {
        width: 42px;
        height: 42px;
        background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png") no-repeat;
        background-size: 42px 42px;
        position: absolute;
        right: 30px;
        top: 30px;
        border-radius: 50%;
        z-index: 1;
    }
    .title {
        margin-top: 82px;
        width: 658px;
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 41px;
        padding-left: 45px;
        font-weight: bold;
        &-dot {
            width: 5px;
            height: 5px;
            border-radius: 5px;
            background: #FA4000;
        }
        .sub-title{
            color: #C69C6D;
            font-size: 26px;
            margin-top: 8px;
        }
    }
    .content {
        height: 755px;
        overflow-y: scroll;
        padding-bottom: 100px;
        background-color: #fff;
        .item {
            padding-bottom: 60px;
        }
    }
    .content-title {
        margin-bottom: 20px;
        font-weight: bold;
        color: #191F34;
        position: relative;
        padding-left: 47px;
        font-size: 26px;
        line-height: 28px;
        padding-right: 30px;
        &:before {
            content: '';
            width: 8px;
            height: 8px;
            background: #C69C6D;
            border-radius: 8px;
            position: absolute;
            left: 25px;
            top: 11px;
        }
    }
    .content-desi {
        margin-bottom: 30px;
        color: #5E6476;
        font-size: 26px;
        padding-left: 48px; 
        padding-right: 30px;
    }
}
</style>